module.exports = __webpack_public_path__ + "static/media/logo.30f07f04.svg";